import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, message } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { getToken } from "./../../redux/helper/localstorageHelper";
import logoDormakaba from "../../images/logo-dormakaba.png";
import "./Login.css";
const jwt = require("jsonwebtoken");

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      username: "",
      password: "",
    };
  }

  componentDidMount = () => {
    const { history } = this.props;
    const token = getToken("token");
    if (token) {
      const decodedToken = jwt.decode(JSON.parse(token).accessToken);
      const { exp } = decodedToken;
      const now = new Date();
      if (!(now.getTime() > exp * 1000)) {
        history.push("/overview");
      } else {
        localStorage.removeItem("token");
      }
    }
  };

  onUsernameChange = (e) => {
    const { value } = e.target;
    this.setState({
      username: value,
    });
  };

  onPasswordChange = (e) => {
    const { value } = e.target;
    this.setState({
      password: value,
    });
  };

  onFinish = (values) => {
    const { username, password } = values;
    const { history } = this.props;

    this.setState({
      isLoading: true,
    });

    return fetch(`/api/v1/auth/authenticate`, {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
        username,
        password,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          return res
            .json()
            .catch(() => {
              // Couldn't parse the JSON
              throw new Error(res.statusText);
            })
            .then(({ error }) => {
              // Got valid JSON with error response, use it
              throw new Error(error || res.statusText);
            });
        }
        return res.json();
      })
      .then(({ data }) => {
        this.setState({ isLoading: false });
        this.props.authSuccess(data);
        return history.push("/overview");
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
        this.setState({
          isLoading: false,
        });
      });
  };

  render() {
    const { isLoading, username, password } = this.state;

    // dormakaba-theme
    // hafele-theme
    // default-theme
    const theme = "dormakaba-theme";
    let logo = logoDormakaba;

    return (
      <div
        className={`loginLayoutContainer loginLayoutContainerBackground ${theme}`}
      >
        <div className="loginLayoutOverlay" />
        <div className="loginLayoutContent">
          <div className="loginLayoutMain">
            <Card>
              <div className="loginLayoutTop">
                <img alt="logo" className="loginLogo" src={logo} />
              </div>
              <div className="loginTitle">Central Backend</div>
              <Form
                name="normal_login"
                className="login-form"
                initialValues={{
                  remember: true,
                }}
                onFinish={this.onFinish}
              >
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Username!",
                    },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Username"
                    onChange={this.onUsernameChange}
                    disabled={isLoading}
                    autoFocus
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Password!",
                    },
                  ]}
                >
                  <Input
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    placeholder="Password"
                    onChange={this.onPasswordChange}
                    disabled={isLoading}
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                    disabled={isLoading || !username || !password}
                    style={{ width: "100%" }}
                  >
                    Log in
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);
